class ProductFeatures extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.elements = {
      slider: this.querySelector(".product-features__slider"),
      slides: this.querySelectorAll(".splide__slide"),
    };
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    this.slider = new Splide(this.elements.slider, {
      perPage: this.elements.slides.length < 3 ? 2 : 2.3,
      gap: "2rem",
      pagination: false,
      arrows: this.elements.slides.length > 2,
      focus: 0,
      omitEnd: true,
      breakpoints: {
        768: {
          perPage: 1,
          arrows: this.elements.slides.length > 1,
        },
      },
    }).mount();
  }
}

if (!customElements.get("product-features")) {
  customElements.define("product-features", ProductFeatures);
}
